import { useState, useEffect } from 'react'
import { get, ref } from "firebase/database";

import { formatDate, formatDateLong, formatDate3 } from '../../utils/formatDates.js';
import { db } from '../../utils/firebaseApp.js';

export default function CreditsDashboardHistory({ usersInfo }) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [buyTrigger, setBuyTrigger] = useState([]);

    useEffect(() => {
        const fetchBuyTrigger = async () => {
            try {
                // Fetch all user billing data within the time range
                const buyTriggerRef = ref(db, 'stripe/logs');
                get(buyTriggerRef).then((snapshot) => {
                    if (snapshot.exists()) {
                        let data = snapshot.val();

                        let history = [];
                        Object.keys(data).forEach((transactionId) => {
                            let element = data[transactionId];
                            history.push({
                                userId: element.userId,
                                value: element.value,
                                currency: element.currency,
                                pages: element.pages,
                                type: element.type,
                                timestamp: element.timestamp,
                                transactionId: transactionId,
                            });
                        });

                        // sort history by timestamp
                        history.sort((a, b) => {
                            const dateA = new Date(a.timestamp);
                            const dateB = new Date(b.timestamp);
                            return dateB - dateA; // sort in descending order
                        });

                        setBuyTrigger(history);
                    }
                }).catch((error) => {
                    console.error('Error fetching user billing data', error);
                });

            } catch (error) {
                console.error('Error fetching user billing data', error);
            }
        };
        fetchBuyTrigger();
    }, []);

    if (error) return <p>Error: {error.message}</p>;

    return (
        <div className="mt-4 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className='mb-5'></div>
                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                        Email
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        User Id
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Value
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Pages
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Type
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200 bg-white">
                                {buyTrigger.map((element, index) => (
                                    <tr key={index}>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                            {usersInfo[element.userId] ? usersInfo[element.userId].email : element.userId}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.userId}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            ${(element.value / 100).toFixed(2)}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {/* if element.pages is present put x pages else put - */}
                                            {element.pages ? element.pages : '-'}
                                            {element.pages ? ' pages' : ''}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.type ? element.type : '-'}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {element.timestamp}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}